<template>
  <div class="article-edit-container">
    <div>
      <bread-crumb />
    </div>
    <div class="global-table-container">
      <basic-form
        ref="basicForm"
        :form-data="formData"
      >
        <template #company_id>
          <a-select
            v-decorator="['company_id',{rules: [
              { required: true, message: '请选择企业' },
            ],initialValue:data.company_id}]"
            placeholder="请选择企业"
          >
            <a-select-option
              v-for="item in companyData"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </template>
        <template #group_id>
          <a-tree-select
            v-decorator="['group_id',{rules: [
              { required: true, message: '请选择栏目' },
            ],initialValue:data.group_id?String(data.group_id):undefined}]"
            class="select-container"
            :tree-data="parentData"
            placeholder="请选择栏目"
          />
        </template>
        <template #name>
          <a-input
            v-decorator="['name',{rules: [
              { required: true, message: '请输入标题' },
            ],initialValue:data.name}]"
            placeholder="请输入标题"
          />
        </template>
        <template #post_excerpt>
          <a-input
            v-decorator="['post_excerpt',{rules: [
              { required: true, message: '请输入摘要' },
            ],initialValue:data.post_excerpt}]"
            placeholder="请输入摘要"
          />
        </template>
        <template #post_content>
          <div
            ref="editor"
          />
        </template>
        <template #speaker>
          <a-input
            v-decorator="['speaker',{rules: [
              { required: false, message: '请输入主讲人' },
            ],initialValue:data.speaker}]"
            placeholder="请输入主讲人"
          />
        </template>
        <template #video_id>
          <a-upload
            v-decorator="[
              'video_id',
              {
                initialValue: data.video_id,
                rules: [{ required: true, message: '请上传视频' }] ,
                valuePropName: 'fileList',
                getValueFromEvent: normFile,
              },
            ]"
            name="upload"
            accept=".mp4"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            :data="{fileType:'video',}"
            :before-upload="beforeUpload"
            :custom-request="changeFile"
            :disabled="loading"
          >
            <video
              v-if="videoUrl"
              ref="videoRef"
              :src="videoUrl"
              width="300"
              height="200"
            />
            <div v-else>
              <a-progress
                v-if="loading"
                type="circle"
                :percent="percent"
                :width="80"
                :status="progressStatus"
              />
              <a-icon
                v-else
                type="plus"
              />
              <div class="ant-upload-text">
                上传
              </div>
            </div>
          </a-upload>
        </template>
        <template #video_time>
          <a-input
            v-decorator="['video_time',{rules: [
              { required: true, message: '请输入时长' },
            ],initialValue:data.video_time}]"
            placeholder="视频时长"
            disabled
          />
        </template>

        <template #list_order>
          <a-input-number
            v-decorator="['list_order',{rules: [
              { required: false, message: '请输入排序' },
            ],initialValue:data.list_order}]"
            placeholder="请输入排序"
          />
        </template>
      </basic-form>
      <div style="text-align:right">
        <a-button @click="onCancel">
          返回
        </a-button>
        <a-button
          :loading="btnIsLoading"
          type="primary"
          style="margin-left:20px;"
          @click="handleSubmit"
        >
          提交
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import * as qiniu from 'qiniu-js';
import { formData } from './../data/index';
import E from 'wangeditor';
import moment from 'moment';
import {randomWord, secondToDate} from './../utils/index';
export default {
  data() {
    return {
      formData,
      companyData: [],
      parentData: [],
      loading: false,
      btnIsLoading: false,
      editorContent: '',
      data: {video_id: []},
      percent: 0,
      videoUrl: '',
      progressStatus: 'normal',
    };
  },
  async mounted() {
    // 获取栏目
    this.getParentData();
    // 获取企业
    this.getCompanyData();
    // 编辑内容
    let editor = new E(this.$refs.editor);
    editor.customConfig={
      onchange: (html) => {
        this.editorContent = html;
      },
      customUploadImg: async(files, insert)=> {
        console.log('mounted -> files', files);
        let formData=new FormData();
        files.forEach((item)=>{
          formData.append('upload[]', item);
        });

        let result =await this.$http.post('/fileup/uploadMore', formData);
        if(result.data.status===1){
          result.data.data.data_list.forEach((item)=>{
            insert(item);
          });

        }
      },
    };
    editor.create();
    // 回显
    if(this.$route.query.id){
      await this.getData({id: this.$route.query.id});
      await editor.txt.html(this.editorContent);
    }

  },
  methods: {
    // 回显
    async getData(params){
      let result=await this.$http.post('/portalPost/info', params);
      if(result.data.status===1){
        let temp=result.data.data;
        this.data=temp;
        this.$set(this.data, 'video_id', [{
          uid: temp.video_id,
          url: temp.video_url,
          status: 'done',
          name: 'img',
        }]);
        console.log(this.data);
        this.videoUrl=temp.video_url;
        this.editorContent=temp.post_content;
      }
    },
    normFile(e) {
      if (e && e.file.status === 'uploading') {
        this.loading = true;
        this.videoUrl='';
        this.$refs.basicForm.form.setFieldsValue({'video_time': ''});
      }
      if (e && e.file.status === 'done') {
        const fileList = [
          {
            uid: e.file.response.data.id,
            status: 'done',
            name: 'img',
            url: e.file.response.data.url,
          },
        ];
        this.loading = false;
        return fileList;
      }
      return e.fileList;
    },
    // 上传前
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$message.error('视频大小不得超过100M！');
      }
      return isLt2M;
    },
    // 上传后
    async changeFile(value){
      let _this=this;
      let date = new Date();
      let file = value.file; // 对象，上传的文件
      let num=randomWord();
      let index=file.name.lastIndexOf('.');
      let suffix=file.name.substring(index+1, file.name.length);
      let key =`default/${moment(date.toLocaleDateString()).format('YYYYMMDD')}/${moment(date).unix()}${num}.${suffix}`; // 文件资源名

      let config = {
        useCdnDomain: true,
        region: qiniu.region.z2,
        checkByMD5: true,
      };

      let putExtra = {
        fname: file,
        params: {},
        mimeType: ['video/mp4'],
      };
      let observe = {
        next(res) {
          _this.percent=parseInt(res.total.percent);
        },
        error(err) {
          _this.$message.warning('上传失败，请重新上传！');
          _this.progressStatus='exception';
        },
        async complete(res) {
          // 完成后的操作
          console.log(res);
          _this.videoUrl=`https://cdncs.cdheiguo.com/${res.key}`;
          _this.loading=false;
          _this.percent=0;
          // 上传
          let result=await _this.$http.post('fileup/check_file', {file_name: file.name, file_path: key, key});
          if(result.data.status===1){
            console.log('complete -> result', result);
            let data=[
              {
                uid: result.data.data.id,
                url: result.data.data.url,
                status: 'done',
                name: 'img',
              },
            ];
            _this.$refs.basicForm.form.setFieldsValue({'video_id': data});
            let result1=await _this.$http.post('/portalPost/getVideoTime', {video_id: result.data.data.id});
            if(result1.data.status===1){
              console.log(22222);
              console.log('222222',);
              _this.$refs.basicForm.form.setFieldsValue({'video_time': result1.data.data.video_time});
            }
          }

        },
      };
      let result=await this.$http.post('/fileup/get_token');
      let token=result.data.data.token;
      // 开始上传  token 需要找后端获取(单独的方法)
      let observable = qiniu.upload(file, key, token, putExtra, config);
      let subscription = observable.subscribe(observe);
    },
    // 获取企业
    async getCompanyData() {
      let result = await this.$http.post( '/company/getCompanyList');
      if (result.data.status === 1) {
        let data = result.data.data.data_list.map((item) => {
          return { name: item.team_name?item.team_name:item.companyInfo.qichacha_name, ...item };
        });
        this.companyData = data;
      }
    },
    // 递归处理
    dealData(data) {
      data.forEach((item) => {
        item.title = item.name;
        item.key = item.id;
        item.value = String(item.id);
        item.children = item.child_list;
        item.selectable=false;
        if (item.child_list && item.child_list.length > 0) {
          item.child_list.forEach((list)=>{
            list.title = list.name;
            list.key = list.id;
            list.value = String(list.id);
          });
        }
      });
      return data;
    },
    // 获取栏目数据
    async getParentData() {
      let result = await this.$http.post('/groups/adminGetList');
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.parentData = this.dealData(JSON.parse(JSON.stringify(data)));
      }
    },
    // 提交
    handleSubmit() {
      this.$refs.basicForm.form.validateFields(async(err, values) => {
        console.log('TCL: handleSubmit -> values', values);
        if (!err) {
          if (this.$route.query) {
            this.id = this.$route.query.id;
          }
          let data = {
            id: this.id ? this.id : undefined,
            obj_type: '2',
            polymorphic_type: '0',
            company_id: values.company_id,
            group_id: values.group_id,
            name: values.name,
            post_excerpt: values.post_excerpt,
            hits: String(values.hits),
            likes: String(values.likes),
            favorites: String(values.favorites),
            list_order: String(values.list_order),
            speaker: values.speaker,
            video_id: values.video_id[0].uid,
            video_time: values.video_time,
            post_content: this.editorContent,
          };
          this.btnIsLoading = true;
          let result = await this.$http.post(
            '/portalPost/update',
            data,
          );
          this.btnIsLoading=false;
          if (result.data.status === 1) {
            this.$message.success('操作成功！');
            this.$router.back();
          }
        }
      });
    },
    // 返回
    onCancel() {
      this.$router.back();
    },
  },
};
</script>
<style scoped lang="scss">
.article-edit-container {
  /deep/ .ant-form-item-no-colon {
    .ant-form-item-label {
      text-align: right;
      .ant-form-item-required {
        &::before {
          display: inline-block;
          content: "*";
          color: #f5222d;
          font-size: 14px;
          line-height: 1;
        }
        &::after {
          content: "";
        }
      }
    }
  }
  .ant-input-number {
    width: 100%;
  }
}

</style>